import React from "react"

export default function Blog024() {
  return (
    <section>
    <article>
    <h2>24. 11-07-2022</h2>
          <h3>Work Mode</h3>
          <p>
          <strong>Hello!</strong>
          <br /><br />
          <strong>Some History</strong>
          <br /><br />
          For all the new readers, my name is Eric Polley. I am a Software Developer with a background 
          in freelance animation. I recorded a vlog video where I talk a bit about my history and where 
          I am at with programming; I added a link to that video in the links of this blog post.
          <br /> I am proficient with programs like Blender and Animated CC. I found I 
          had the most fun while learning a new program and exploring possibilities. This lead me to a series 
          of trying game engines and object-oriented languages for a few years. I have created content with 
          Unreal, Unity, and RPG Maker. This was fun, but I found that each engine had its own limitation. 
          <br />
          I decided time after time to hang it up. It became apparent that if I had an understanding of the langauges, 
          I would be able to manipulate the engine; or disregard the engine all together. This realization was during the 
          height of my yearly animation work load, therefore time would not allow the addition of a new skill. Like most people, 
          I put it off. I put it off for a long time. 
          <br />
           I am pushing myself from a role as Lead Animator for several reasons. I really want to increase my skills and abilities. 
           As an animator I felt limitations, even with the title. Animation is fun. It is difficult for some people to see animation 
           as a serious medium. I would like a career that reflects the amount that I can accomplish. 

          <br /><br />
          <strong>Work Mode</strong>
          <br /><br />
          This is a nice segway, with a big bold title in the middle. Work Mode. <br />
          I am applying to jobs and gigs alike. The second job I applied for gave me interview that was very pleasant. 
          This fills me with confidence and a positive outlook toward the future.
          I am moving forward and upward with high hopes and reasonable expectations. 
          <br />
          I have created a Resume with Bootstrap. I am also using Bootstrap to write cover letters. I feel this is an 
          easy way to immediately demonstrate basic web development abilities. 
          <br />
          I have updated my website using React. The site is full of iframes that pull the information from other websites I 
          have hosted under CNames of the same domain. I found Netlify to be extremely useful. 
          <br />
          I continue to learn. Last time I wrote a blog I talked a lot about how I am learning REST. I decided since then to take 
          some time to really focus on ReactJS. I may decide to use NextJS over REST. I need to use ReactJS a bit more to 
          ensure I pick the best tool for the job. 
          <br />
          <br />
          Alright. Now with all that out. I am going to spend some time with tutorials today. It is very snowy outside, great day 
          to stay inside. On the computer. ...Not that I don't do that every day anyways. Alright. Alright! I am going to get 
          back to work now. Thank you for reading!
          <br />
          <br />
          ~Eric Polley
          <br />

          </p>
          
          </article>

        <h4>Links</h4>
        <br />
        <ul>
        <li>
            <a
              href="https://www.youtube.com/watch?v=bUmqZALqzic"
              title="Vlog: Becoming a Developer: Month 4"
              target="_blank"
              rel="noopener noreferrer" 
            >
              <strong><p>Vlog: Becoming a Developer: Month 4</p></strong></a
            >
          </li>
          <li>
            <a
              href="http://ericpolley.com"
              title="Check out my Portfolio!"
              target="_blank"
              rel="noopener noreferrer" 
            >
              <strong><p>Eric Polley's Website</p></strong></a
            >
          </li>
        </ul>
        </ section >
  )
}
